module.exports = __webpack_public_path__ + "img/layermark-logo.767cacd4.svg";